<template>
  <div>
    <a-switch :checked="field.value" @change="onChange">
      <!-- checked-children="已开启"
      un-checked-children="已关闭"-->
    </a-switch>
  </div>
</template>
<script>
import { props } from './helper'
import { defineComponent } from 'vue'

export default defineComponent({
  props,
  setup(props) {
    const onChange = e => {
      props.handleChange(e)
    }
    return { onChange }
  }
})
</script>
<style lang="less" scoped></style>
